import pluralize from "pluralize";

const IRREGULAR_VERBS =
  "added|removed|sent|built|put|set|cut|hit|shut|met|read|made|paid|said|found|held|told|sold|lost|bought|brought|thought|taught|caught|fought|sought";

const VERB_PATTERN = new RegExp(
  `\\b((?:\\w+-)*(?:\\w+ed|${IRREGULAR_VERBS}))\\b`,
  "gi"
);

const ADJECTIVE_PATTERN = /\b(eligible|ineligible|available)\b/gi;

const isAdverb = (word: string): boolean => /ly$/i.test(word);

const findSplitPoint = (
  title: string,
  pattern: RegExp
): { nounPhrase: string; remainder: string } | undefined => {
  for (const match of title.matchAll(pattern)) {
    const index = match.index!;
    const nounPhrase = title.substring(0, index).trim();

    if (!nounPhrase) continue;

    const words = nounPhrase.split(" ");
    const lastWord = words[words.length - 1];

    if (isAdverb(lastWord)) continue;

    return { nounPhrase, remainder: title.substring(index) };
  }

  return undefined;
};

const findMainVerb = (
  title: string
): { nounPhrase: string; remainder: string } | undefined =>
  findSplitPoint(title, VERB_PATTERN);

export const pluralizeEventTitle = (title: string, count: number): string => {
  if (count <= 1) return title;

  const parsed =
    findMainVerb(title) ?? findSplitPoint(title, ADJECTIVE_PATTERN);

  if (!parsed) return title;

  const words = parsed.nounPhrase.split(" ");
  const lastWord = words[words.length - 1];
  words[words.length - 1] = pluralize(lastWord);

  return `${count} ${words.join(" ")} ${parsed.remainder}`;
};
